import 'react-datepicker/dist/react-datepicker.css'

import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * id of the field
   */
  id: PropTypes.string.isRequired,
  /**
   * Name of the field
   * If no name is passed id is used as name
   */
  name: PropTypes.string,
  /**
   * Title of the field. Must be a FormattedMessage id
   */
  title: PropTypes.string,
  /**
   * Callback called when an option is selected
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Value of the field
   */
  value: PropTypes.string,
  /**
   * validation errors messages
   */
  errors: PropTypes.arrayOf(PropTypes.string),
  /**
   * Class to style the title
   */
  titleClassName: PropTypes.string,
  /**
   * Class to override default control styles
   */
  className: PropTypes.string,
  /**
   * Indicates if field is required
   */
  required: PropTypes.bool,
  /**
   * If true, displays label and input side-by-side (like PropertyField)
   */
  inline: PropTypes.bool,
  /**
   * Class of the container wrapper
   */
  containerClassName: PropTypes.string,
}

function DateField(props) {
  const {
    id,
    name = null,
    title = null,
    onChange,
    value = null,
    errors = [],
    titleClassName = '',
    className = '',
    required = false,
    inline = false,
    containerClassName = '',
    ...rest
  } = props ?? {}

  if (inline) {
    const { style: restStyle, ...restWithoutStyle } = rest
    return (
      <Row className={clsx('mb-2 align-items-center', containerClassName)}>
        {title && (
          <Col sm="4" className={clsx('text-bold text-muted', titleClassName)}>
            <FormattedMessage id={title} />
            {required && <span className="font-size-regular text-color-danger">*</span>}
          </Col>
        )}
        <Col sm={title ? '8' : '12'} style={{ marginLeft: title ? '-4px' : '0' }}>
          <Form.Control
            {...restWithoutStyle}
            type="date"
            id={id}
            name={name || id}
            value={value}
            onChange={onChange}
            className={clsx(errors?.length && 'error-border', className)}
            style={restStyle}
          />

          {errors?.map((errorMessage) => (
            <div key={errorMessage} className="text-color-danger mt-2">
              {errorMessage}
            </div>
          ))}
        </Col>
      </Row>
    )
  }

  return (
    <div className={clsx('mb-3', containerClassName)}>
      {title && (
        <p className={clsx('mb-2', titleClassName)}>
          <FormattedMessage id={title} />
          {required && <span className="font-size-regular text-color-danger">*</span>}
        </p>
      )}

      <Form.Control
        {...rest}
        type="date"
        id={id}
        name={name || id}
        value={value}
        onChange={onChange}
        className={clsx(errors?.length && 'error-border', className)}
      />

      {errors?.map((errorMessage) => (
        <div key={errorMessage} className="text-color-danger mt-2">
          {errorMessage}
        </div>
      ))}
    </div>
  )
}

DateField.propTypes = propTypes

export default DateField
